export default __webpack_public_path__ + "static/Services-b4064f776296d102d725a60ae3c1f479.png";